import "dragula/dist/dragula.css"
import dragula from "dragula"

// Support legacy build system.
window.dragula = dragula;